// @flow
import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'ramda';
import Footer from '../components/Global/Footer';
import ConnectedHeader from '../components/Global/Header';
import { load as loadAuth } from '../stores/auth';
import safelyHoistStatics from '../helpers/safelyHoistStatics';

type Props = {
  match: any,
  user: any | null
};

/**
 * Helper component that will render singular components server side in the context
 * of the application
 */
class StaticComponentRenderer extends Component<Props> {
  static fetchData(store) {
    return store.dispatch(loadAuth());
  }

  render() {
    let element;

    switch (this.props.match.params.component) {
      case 'header':
        element = (
          <ConnectedHeader
            user={this.props.user}
            callback={this.onNavToggle}
            isStatic
          />
        );
        break;
      case 'footer':
        element = <Footer />;
        break;
      default:
        return false;
    }

    return (
      <Route
        render={({ staticContext }) => {
          if (staticContext) {
            // eslint-disable-next-line no-param-reassign
            staticContext.componentRender = true;
          }

          return element;
        }}
      />
    );
  }
}

const mapStateToProps = state => ({ user: state.auth.user });

const appComposition = compose(
  withRouter,
  connect(mapStateToProps)
)(StaticComponentRenderer);

export default safelyHoistStatics(appComposition, StaticComponentRenderer);
